export const actionsEnum = {
  PUSH: 'PUSH',
  CLEAR: 'CLEAR'
};

export const typesEnum = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING'
};
